<template>
    <div class="ResidentialInventoryCount">
        <!--<div>
            <h2>
                Medication Count
                <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="RefreshDataTable()" class="olive-green-text pointer" /> 
            </h2>
        </div>-->
        <div v-if="DataList.length > 0" style="overflow-x:auto;">

            <table class="table-utility" >
                <thead>
                    <tr style="position:sticky; top: 0; background-color: white;">
                        <th>Client</th>
                        <th>Medication</th>
                        <th>Status</th>
                        <th>Last Count At</th>
                        <th>Last Count Qty</th>
                        <th>Last County By</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody v-for="(client, key) in GroupedMedicationInventories">
                    <tr>
                        <td>{{ client.ClientName }}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr v-for="med in client.Meds">
                        <td></td>
                        <td>{{ med.MedicationDescription }}</td>
                        <td>{{ med.Status }}</td>
                        <td>{{ formatDate(med.LastCountAt,"MM/DD/YY hh:mm A") }}</td>
                        <td>{{ med.LastCountQuantity }}</td>
                        <td>{{ med.LastCountBy }}</td>
                        <td @click="ShowNewCount(med)" class="pointer center-text"><i class="fa fa-plus olive-green-text" /></td>
                    </tr>
                </tbody>
            </table>

            <!--<vuetable :fields="TableOptions.Fields"
                      pagination-path=""
                      :api-mode="false"
                      class="vue-datatable"
                      :data-manager="DataManager"
                      ref="datatable">

                <template slot="NewCount" scope="props">
                    <div class="NewCount" v-if="Filters.Status == 'Present'">
                        <font-awesome-icon :icon="['fa', 'plus']" v-on:click="ShowNewCount(props.rowData)" class="olive-green-text pointer" />
                    </div>
                </template>
            </vuetable>-->
        </div>

        <!--NEW COUNT MODAL-->
        <b-modal ref="modal-newcount" size="md" title="RECORD MEDICATION COUNT" hide-footer>
            <b-container>
                <b-form @submit="Save" v-if="TargetRecord.Id">
                    <b-row>
                        <b-col>
                            <h3>Medication Info</h3>
                            <div class="form-group">
                                <label>Medication Name:</label>
                                <p class="bold">{{TargetRecord.MedicationName}}</p>
                            </div>
                            <div class="form-group">
                                <label>Strength:</label>
                                <p class="bold">{{TargetRecord.MedicationStrength}}</p>
                            </div>
                            <div class="form-group">
                                <label>Pharmacy:</label>
                                <p class="bold">{{TargetRecord.PharmacyName}}</p>
                            </div>
                            <div class="form-group">
                                <label>Prescription #:</label>
                                <p class="bold">{{TargetRecord.PrescriptionNumber}}</p>
                            </div>
                            <div class="form-group">
                                <label>Quantity Filled:</label>
                                <p class="bold">{{TargetRecord.QuantityFilled}}</p>
                            </div>
                            <div class="form-group">
                                <label>Date Filled:</label>
                                <p class="bold">{{formatDate(TargetRecord.DateFilled,'MM/DD/YY')}}</p>
                            </div>
                            <div class="form-group">
                                <label>Expires:</label>
                                <p class="bold">{{formatDate(TargetRecord.ExpirationDate,'MM/DD/YY')}}</p>
                            </div>
                        </b-col>
                        <b-col>
                            <h3>Count</h3>
                            <div class="form-group">
                                <label>Actual Count:</label>
                                <input v-model="CountRecord.ActualQuantity" type="number" class="form-control" step="0.1" required />
                            </div>
                            <div class="form-group">
                                <label>Comments:</label>
                                <textarea v-model="CountRecord.Comments" class="form-control" rows="2"></textarea>
                            </div>
                            <div class="form-group">
                                <label>Count Type:</label>
                                <select v-model="CountRecord.ShiftPhase" type="text" class="form-control" required>
                                    <option value="Shift Start">Shift Start</option>
                                    <option value="Shift End">Shift End</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <h4>This Medication is being counted by: <span class="bold">{{ UserPrivateProfile.FirstName }} {{ UserPrivateProfile.LastName }}</span></h4>
                            <p>If you are not {{ UserPrivateProfile.FirstName }} {{ UserPrivateProfile.LastName }}, you must log out of the system and log in under your own profile.</p>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelNewCount()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                RECORD COUNT
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>
</template>

<script>

    //import components
    //import Vue from 'vue';
    import Vuetable from 'vuetable-2/src/components/Vuetable'

    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);


    export default {
        props: [
            "ResidenceId"
        ],
        data: function () {
            return {
                Filters: {
                    Status: "Present"
                },
                TargetRecord: {},
                CountRecord: {},
                TableOptions: {
                    Fields: [
                        {
                            name: 'ClientName',
                            title: "Client"
                        },
                        {
                            name: 'MedicationDescription',
                            title: "Medication"
                        },
                        {
                            name: 'LastCountAt',
                            title: "Last Count At",
                            callback: 'formatDate|MM/DD/YY hh:mm A'
                        },
                        {
                            name: 'LastCountQuantity',
                            title: "Last Count Qty"
                        },
                        {
                            name: 'LastCountBy',
                            title: "Last Count By"
                        },
                        {
                            name: '__slot:NewCount',
                            title: 'Actions'
                        }
                    ]
                },
                DataList: []
            };
        },
        methods: {
            RefreshDataTable() {
                this.GetList(true);
            },

            //ENDPOINTS
            GetList(displayLoad = true) {
                this.Filters.ResidenceID = this.ResidenceId
                this.$MasterAPI.ExecuteRequest("GET", "Medication/Count/Residence", this.Filters, this.GetListSuccess, () => { }, displayLoad);
            },
            GetListSuccess(response) {
                this.DataList = response.data.data;
                //this.$refs.datatable.refresh();
            },
            Save(e) {
                e.preventDefault();

                this.$MasterAPI.ExecuteRequest("POST", "Medication/Count", this.CountRecord, this.SaveSuccess, () => { }, true);
            },
            SaveSuccess(response) {
                this.GetList(true);
                if (response.data.data.ActualMatchesExpected == false) {
                    alert("ALERT!!  The quantity you entered of " + response.data.data.ActualQuantity + " does not match the expected quantity for this medication.  This indicates that either your count was incorrect or a medication error has been made somewhere.  Verify your count, and re-record your count if needed, or attempt to discover the source of the error.");
                }
                this.$refs["modal-newcount"].hide();
            },
            // UI
            ShowNewCount(rowData) {
                this.TargetRecord = JSON.parse(JSON.stringify(rowData));
                this.CountRecord = {
                    MedicationInventoryID: rowData.MedicationInventoryID
                };
                this.$refs["modal-newcount"].show();
            },
            CancelNewCount() {
                this.$refs["modal-newcount"].hide();
            },
            
            // AUXILLARY
            formatDate(value, fmt = 'MM/DD/YY', defaultVal = '') {
                return (value == null)
                    ? defaultVal
                    : moment(value, 'YYYY-MM-DD HH:mm:ss').format(fmt)
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            RedrawTable() {
                this.$refs.datatable.refresh();
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.DataList
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }

                } else {
                    return [];
                }
            }
        },
        components: {
            Vuetable,
            flatPickr
        },
        computed: {
            UserPrivateProfile: function () {
                return this.$store.state.User.PrivateProfile;
            },
            GroupedMedicationInventories: function () {
                let output = {};
                this.DataList.forEach(function (item) {
                    let k = item.ClientSubProgramMembershipID
                    if (output.hasOwnProperty(k) == false) {
                        output[k] = {
                            ClientName: item.ClientName,
                            Meds: []
                        };
                    }
                    output[k].Meds.push(item);
                });

                return output;
            }
        },
        mounted() {
            this.GetList(true);
        }
    }
</script>

<style scoped>
    /*sticky table header*/
    /deep/ .vue-datatable thead {
        position: sticky;
        top: -1px;
        background: white;
    }
    /*no wrap text on columns*/
    /deep/ .vue-datatable tbody td {
        white-space: nowrap !important;
    }
</style>